import { IconDeviceFloppy } from "@tabler/icons-react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@fronterahealth/frontera-ui-components/ui/tooltip";

import { useHasUnsavedFields } from "@components/ReportField/useHasUnsavedFields";

export const FormSavingIndicator: React.FC = () => {
  const hasUnsavedFields = useHasUnsavedFields();
  if (!hasUnsavedFields) return null;

  return (
    <Tooltip>
      <TooltipTrigger render={<output aria-label="Saving changes" />}>
        <IconDeviceFloppy className="size-5 animate-pulse text-text-secondary" stroke={1} />
      </TooltipTrigger>
      <TooltipContent>Saving changes…</TooltipContent>
    </Tooltip>
  );
};
